import React from 'react';

import cx from 'classnames';

import chestImg from './chest.webp';
import styles from './Chests.module.scss';

const CHEST_PIECE_CLASS_NAMES = {
  A: styles.chestPieceA,
  B: styles.chestPieceB,
  C: styles.chestPieceC,
  D: styles.chestPieceD,
  E: styles.chestPieceE,
  F: styles.chestPieceF,
  G: styles.chestPieceG,
  H: styles.chestPieceH,
  I: styles.chestPieceI,
} as const;

const IDLE_CHEST_PIECES = ['A', 'B', 'C', 'D', 'E', 'F'] as const;
const OPENING_CHEST_PIECES = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
] as const;

type TChestVisualVariant = 'idle' | 'opening';

interface IChestVisualProps {
  dayLabel?: string;
  variant: TChestVisualVariant;
  isPendingOpen?: boolean;
  isExplosionOverlay?: boolean;
}

const ChestPieces: React.FC<{ variant: TChestVisualVariant }> = ({
  variant,
}) => {
  const pieces =
    variant === 'opening' ? OPENING_CHEST_PIECES : IDLE_CHEST_PIECES;

  return (
    <span aria-hidden="true" className={styles.chestPieces}>
      {pieces.map((piece) => (
        <span
          className={cx(styles.chestPiece, CHEST_PIECE_CLASS_NAMES[piece])}
          key={piece}
        />
      ))}
    </span>
  );
};

export const ChestVisual: React.FC<IChestVisualProps> = ({
  dayLabel = '',
  isExplosionOverlay = false,
  isPendingOpen = false,
  variant,
}) => {
  const isOpening = variant === 'opening';
  const showDayChestLabel = !isExplosionOverlay;

  return (
    <div
      className={cx(
        styles.chestVisual,
        isExplosionOverlay && styles.chestExplosionOverlay,
      )}
    >
      {isOpening ? (
        <>
          <span aria-hidden="true" className={styles.chestFlash} />
          <span aria-hidden="true" className={styles.chestSparks}>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((sparkIndex) => (
              <span
                className={styles.chestSpark}
                key={sparkIndex}
                style={{ '--i': sparkIndex } as React.CSSProperties}
              />
            ))}
          </span>
        </>
      ) : null}
      <div className={styles.chestImage}>
        <ChestPieces variant={variant} />
        <img alt="" className={styles.chestImageBase} src={chestImg} />
        {showDayChestLabel ? (
          <span
            className={cx(
              styles.dayChestLabel,
              isOpening
                ? styles.dayChestLabelHidden
                : isPendingOpen && styles.dayChestLabelOpening,
            )}
          >
            {dayLabel}
          </span>
        ) : null}
      </div>
    </div>
  );
};
